import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MenuPage from './MenuPage';
import './styles.styl';
import complete from '../../assets/images/global-complete.svg';
import lock from '../../assets/images/global-lock.svg';
import unlocked from '../../assets/images/global-unlock.svg';
import ribbon from '../../assets/images/global-ribbon.svg';
import lockedRibbon from '../../assets/images/global-ribbon-locked.svg';
import caretUp from '../../assets/images/global-caret-up.svg';
import caretDown from '../../assets/images/global-caret-down.svg';

const mapStateToProps = state => ({
  completed: state.task.completed
});

class MenuSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: this.calcIsCurrentSection(props),
      pagesCompleted: this.calcPagesCompleted(props),
      sectionStatus: this.determineAvailableSections()
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let newState = {
      current: this.calcIsCurrentSection(nextProps),
      pagesCompleted: this.calcPagesCompleted(nextProps),
      sectionStatus: this.determineAvailableSections()
    };

    this.setState(newState);
  }

  calcIsCurrentSection(props) {
    return props.children.some(child => {
      return child.path === props.currentPage;
    });
  }

  calcPagesCompleted(props) {
    let pagesCompleted = 0;
    props.children.forEach(function(child) {
      if (props.completed.includes(child.path)) {
        pagesCompleted++;
      }
    });
    return pagesCompleted;
  }

  getLinkClasses() {
    return classNames('menu__section__link', {
      'menu__section__link--current': this.state.current,
      'menu__section__link--completed':
        this.state.pagesCompleted === this.props.children.length
    });
  }

  handleClick = event => {
    event.preventDefault();
    this.setState(() => {
      return {
        ...this.state,
        sectionStatus: this.determineAvailableSections
      };
    });
    this.props.onClick();
  };

  determineAvailableSections = () => {
    let sectionStatus = {
      available: false,
      completed: true
    };
    // It is possible for an item to be both available and not completed.
    // In this edge case,
    if (this.props.children && this.props.children.length > 0) {
      this.props.children.forEach(child => {
        if (this.props.completed.includes(child.path)) {
          // if any of the child path ARE present in the completed array, this section is available.
          sectionStatus.available = true;
        } else {
          // if any of the child.path is not present in completed array, this section is not completed.
          return (sectionStatus.completed = false);
        }
      });
      return sectionStatus;
    }
  };

  determineLeftIcon = () => {
    if (this.props.last) {
      if (this.state.current) {
        return ribbon;
      } else {
        return lockedRibbon;
      }
    } else if (this.state.sectionStatus && this.state.sectionStatus.completed) {
      return complete;
    } else if (
      (this.state.sectionStatus && this.state.sectionStatus.available) ||
      this.state.current
    ) {
      return unlocked;
    } else {
      return lock;
    }
  };

  iconClasses = (active, left) => {
    return classNames(
      {
        'menu__section__link__icon--active': active
      },
      `menu__section__link__icon-${left ? 'left' : 'right'}`,
      'menu__section__link__icon'
    );
  };

  determinePageNumber = () => {
    const { currentPage, children, open } = this.props;
    let currentPageIndex = this.state.pagesCompleted;
    if (open) {
      children.forEach((child, index) => {
        if (child.path === currentPage) {
          return (currentPageIndex = index + 1);
        }
      });
    }
    return currentPageIndex;
  };

  render() {
    return (
      <li className="menu__section">
        <a className={this.getLinkClasses()} href="" onClick={this.handleClick}>
          {this.state.sectionStatus && (
            <span
              className={this.iconClasses(
                this.state.sectionStatus.completed,
                true
              )}
            >
              <img
                className={classNames({
                  'menu__section__link__icon--last': this.props.last
                })}
                src={this.determineLeftIcon()}
                alt=""
              />
            </span>
          )}
          <span className="menu__section__link__title">{this.props.title}</span>
          <span className={this.iconClasses(this.props.open, false)}>
            <img src={this.props.open ? caretUp : caretDown} alt="" />
          </span>
          <span className="menu__section__link__progress">
            ({this.determinePageNumber()} of {this.props.children.length})
          </span>
        </a>
        <ul hidden={!this.props.open}>
          {this.props.children.map(child => {
            return (
              <MenuPage
                key={child.path}
                path={child.path}
                title={child.title}
                currentPage={this.props.currentPage}
                allPathsOn={this.props.allPathsOn}
              />
            );
          })}
        </ul>
      </li>
    );
  }
}

MenuSection.propTypes = {
  children: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(MenuSection);



// WEBPACK FOOTER //
// ../core/src/components/Menu/MenuSection.js